import React, { useState } from "react";
import { Button } from "superbid-ui";
import { FormModal } from "./FormModal/FormModal";
import styles from "./infoContent.module.scss";

interface IInfoContentProps {
    title: string;
    subtitle?: string;
    imgSrc: string;
    hasButton: boolean;
    mainButtonLabel?: string;
    secondaryButtonLabel?: string;
    onClickMainbutton?: () => any;
    onClickSecondaryButton?: () => any;
}

interface IActionButtonsProps {
    onClickMainbutton?: () => any;
    onClickSecondaryButton?: () => any;
    mainButtonLabel: string;
    secondaryButtonLabel?: string;
}

interface ModalTitleProps {
    title?: string;
    subtitle?: string;
    onClick?: (value: any) => void;
}

const ModalTitle: React.FC<ModalTitleProps> = ({
    title,
    subtitle,
    onClick,
}) => {
    const [showForm, setShowForm] = useState(false);

    function handleShowPrimeForm() {
        setShowForm((oldState) => !oldState);
        onClick(showForm);
    }

    return (
        <div className={styles.header}>
            {!showForm && (
                <>
                    <span className={styles.header__title}>{title}</span>
                    {subtitle ? (
                        <span className={styles.header__subtitle}>
                            {subtitle}
                        </span>
                    ) : (
                        <span className={styles.header__subtitle}>
                            Em breve você poderá se tornar um usuário Prime e
                            ter alertas ilimitados,{" "}
                            <span onClick={handleShowPrimeForm}>
                                {" "}
                                cadastre-se aqui{" "}
                            </span>{" "}
                            e te avisaremos assim que essa nova funcionalidade
                            estiver disponível.
                        </span>
                    )}
                    <hr className={styles.header__line}></hr>
                </>
            )}

            {showForm && (
                <iframe
                    src="https://superbid-wjurx.formstack.com/forms/sb_prime"
                    frameBorder="0"
                    loading="eager"
                    scrolling="no"
                    style={{
                        width: 680,
                        height: 700,
                    }}
                />
            )}
        </div>
    );
};

const ActionBtns: React.FC<IActionButtonsProps> = ({
    mainButtonLabel,
    secondaryButtonLabel,
    onClickMainbutton,
    onClickSecondaryButton,
}) => {
    return (
        <div className={styles.container__buttons}>
            <Button
                label={mainButtonLabel}
                className={styles.button}
                template="orange"
                onClick={onClickMainbutton}
            />

            {secondaryButtonLabel && (
                <Button
                    label={secondaryButtonLabel}
                    onClick={onClickSecondaryButton}
                />
            )}
        </div>
    );
};

export const InfoContent: React.FC<IInfoContentProps> = ({
    title,
    subtitle,
    imgSrc,
    hasButton,
    mainButtonLabel,
    secondaryButtonLabel = "",
    onClickMainbutton,
    onClickSecondaryButton,
}) => {
    const [showImg, setShowImg] = useState(true);

    return (
        <div
            className={styles.container}
            style={showImg ? { padding: 48 } : { padding: 0 }}
        >
            <ModalTitle
                title={title}
                onClick={(value) => {
                    setShowImg(value);
                }}
            />

            {showImg && (
                <>
                    <div className={styles.image__main}>
                        <img src={imgSrc} alt="Info Banner" />
                    </div>

                    <div>
                        {hasButton && (
                            <ActionBtns
                                onClickMainbutton={onClickMainbutton}
                                onClickSecondaryButton={onClickSecondaryButton}
                                mainButtonLabel={mainButtonLabel}
                            />
                        )}
                    </div>
                </>
            )}
        </div>
    );
};
